import Tabs from "./Tabs";
import initLazyLoad from "./lazy-load/LazyLoad";
import Slider from "./slider/Slider";
import {BREAKPOINTS} from './ApplicationConfig';
import ApplicationState from "./ApplicationState";
import CompareButton from "./CompareButton";
import initDefaultModalFormLoader from "./modal/DefaultModalFormLoader";

export default function initMainPage(modal)
{
    initCategoriesSlider();
    initLeadersSlider();
    initProductCarouselSlider();

    if (ApplicationState.commonStorage.get('isMobile') == true) {
        initAdvantagesSlider();
    }
    new Tabs('.js-mainpage-tab').init();

    document.querySelectorAll('.mainpage__tab').forEach(node => {
        let tab    = node as HTMLElement;
        let button = tab.querySelector<HTMLElement>('.js-mainpage-expand');

        button.addEventListener('click', () => {
            button.classList.toggle('mainpage__link_with-icon-opened');
            button.innerText = button.classList.contains('mainpage__link_with-icon-opened') ? 'Свернуть' : 'Подробнее';
            tab.firstElementChild.classList.toggle('mainpage__content_expanded');
        });
    });

}

function initLeadersSlider()
{
    let leadersBreakpoints = {}
    leadersBreakpoints[BREAKPOINTS.SM] = {perView: 1, hideNavArrows: true, gap: 5, withShadow: false};
    leadersBreakpoints[BREAKPOINTS.LG] = {perView: 2, hideNavArrows: true};
    leadersBreakpoints[1400] = {perView: 3, hideNavArrows: false};

    let slider = new Slider('#main-page-leaders-slider', {
        type: 'slider',
        bound: true,
        rewindDuration: 500,
        perView: 4,
        gap: 0,
        keyboard: false,
        useScrollableDots: true,
        hideNavArrows: false,
        breakpoints: leadersBreakpoints,
        loadAllSlidesByObserver: true,
        withShadow: true
    });

    slider.on('slider.after.loading', () => {
        new CompareButton('.js-action-compare').init();

        initDefaultModalFormLoader('.js-load-modal');
    });
}

function initProductCarouselSlider()
{
    let leadersBreakpoints = {}
    leadersBreakpoints[BREAKPOINTS.SM] = {perView: 1, hideNavArrows: true, gap: 5, withShadow: false};
    leadersBreakpoints[BREAKPOINTS.LG] = {perView: 2, hideNavArrows: true};
    leadersBreakpoints[1400] = {perView: 3, hideNavArrows: false};

    let tabs = new Tabs('.js-product-carousel-tab');

    tabs.init();

    tabs.list().forEach(control => {
        let slider = new Slider('#' + control.dataset.tabId, {
            type: 'slider',
            bound: true,
            rewindDuration: 500,
            perView: 4,
            gap: 0,
            keyboard: false,
            useScrollableDots: true,
            hideNavArrows: false,
            breakpoints: leadersBreakpoints,
            loadAllSlidesByObserver: true,
            withShadow: true
        });

        slider.on('slider.after.loading', () => {
            new CompareButton('.js-action-compare').init();

            initDefaultModalFormLoader('.js-load-modal');
        });

        control.addEventListener('tabs.after.switch', () => slider.update());
    });
}

function initCategoriesSlider()
{
    let categoryBreakpointOptions = {};
    categoryBreakpointOptions[BREAKPOINTS.SM] = {perView: 2};
    categoryBreakpointOptions[BREAKPOINTS.LG] = {perView: 4};

    new Slider('#main-page-categories-slider', {
        type: 'carousel',
        perView: 5,
        gap: 20,
        keyboard: false,
        useScrollableDots: false,
        breakpoints: categoryBreakpointOptions,
        loadAllSlidesByObserver: true,
    });
}

function initAdvantagesSlider()
{
    let bannerSliderBreakpointOptions = {};
    bannerSliderBreakpointOptions[BREAKPOINTS.SM] = {perView: 1};

    new Slider('#banner-advantages-slider', {
        type: 'carousel',
        perView: 2,
        gap: 20,
        keyboard: false,
        hideNavArrows: true,
        useScrollableDots: true,
        loadAllSlidesByObserver: false,
        adaptiveHeight: true,
        breakpoints: bannerSliderBreakpointOptions,
    });
}